export default "__VITE_ASSET__Df68VDnx__"